import { apiInstance } from '@/api/instance';
import { type Partner, type PartnerMemberRole } from '@/api/routes/partners/partners.api';

/**
 * Signed-out preview of a partner invite (`GET /previews/partner-invites/:token`), the same answer
 * as `GET /partners/invites/:token`. 404 when the invite expired, was used or was withdrawn.
 */
export interface PartnerInvitePreview {
  partner: Pick<Partner, 'displayName' | 'logoUrl'>;
  email: string;
  /** `owner` claims an account the Bodyprint team registered; the others join a team. */
  role: PartnerMemberRole;
  expiresAt: string;
}

export const partnerInvitesApi = {
  preview: (token: string) =>
    apiInstance.get<PartnerInvitePreview>(`previews/partner-invites/${encodeURIComponent(token)}`),
};

export const partnerInvitesApiKeys = {
  preview: (token: string) => ['partner-invite', token] as const,
};
